import React from 'react'
import type { ReviewKeywordSuggestion } from '../api/reviewKeyword'

interface AdminSuggestionDetailModalProps {
  suggestion: ReviewKeywordSuggestion
  onClose: () => void
  formatDate: (dateString: string) => string
}

const AdminSuggestionDetailModal: React.FC<
  AdminSuggestionDetailModalProps
> = ({ suggestion, onClose, formatDate }) => {
  return (
    <div className="p-24px">
      <div className="grid grid-cols-2 gap-16px mb-24px">
        <div>
          <label className="text-style-labelS text-textColorText2 mb-4px block">
            제안 ID
          </label>
          <div className="text-style-body2 text-textColorText2">
            {suggestion.id}
          </div>
        </div>

        <div>
          <label className="text-style-labelS text-textColorText2 mb-4px block">
            작성일
          </label>
          <div className="text-style-body2 text-textColorText2">
            {formatDate(suggestion.created_at)}
          </div>
        </div>

        <div className="col-span-2">
          <label className="text-style-labelS text-textColorText2 mb-4px block">
            사용자
          </label>
          <div className="text-style-body2 text-textColorText2">
            {suggestion.user
              ? `${suggestion.user.nickname} (${suggestion.user.username})`
              : '알 수 없음'}
          </div>
        </div>
      </div>

      <div className="mb-24px">
        <label className="text-style-labelS text-textColorText2 mb-4px block">
          제안 내용
        </label>
        <div className="text-style-body2 text-textColorText2 whitespace-pre-wrap break-words">
          {suggestion.suggestion_text}
        </div>
      </div>

      <div className="flex justify-end mt-24px pt-24px border-t border-brandPrimary-5%">
        <button
          onClick={onClose}
          className={`
            py-10px
            px-20px
            bg-4B3621-80%
            text-white
            rounded-8px
            text-style-button2
            hover:bg-4B3621-80%-70%
            transition-colors
          `}
        >
          닫기
        </button>
      </div>
    </div>
  )
}

export default AdminSuggestionDetailModal
